module.exports = __webpack_public_path__ + "static/img/touzi.6216fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/touzi.png
// module id = ZWGQ
// module chunks = 7